import {
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Size, SpinnerThemes } from '@usitsdasdesign/dds-ng/shared';
import { SpinnerOptions } from '@usitsdasdesign/dds-ng/spinner';
import { copyToClipboard } from '../../../intake/common/intake.util';
import { SharedConstant } from '../../constants/shared.constant';

@Component({
  selector: 'app-generic-picker',
  templateUrl: './generic-picker.component.html',
  styleUrls: ['./generic-picker.component.less'],
})
export class GenericPickerComponent {
  readonly EMPTY: string = SharedConstant.EMPTY_STRING;
  @Input() width: string = 'inherit';
  @Input() stickerMaxHeight: string = '15rem';
  @Input() maxLength: number = SharedConstant.TEXT_MAX_LENGTH_11;
  @Input() placeholder: string = 'Search...';
  @Input() selectedItem: any = null;
  @Input() items: any[] = [];
  @Input() noMatchesText: string = 'No matches found';
  @Input() searchingText: string = 'Searching...';
  @Input() minSearchLength: number = SharedConstant.TEXT_MIN_LENGTH_3;
  @Input() dropdownContentCustomTemplate: TemplateRef<any> | null = null;
  @Input() showDropdown: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() isPickerDisabled: boolean = false;
  @Input() showCopyIcon: boolean = true;
  @Input() showClearIcon: boolean = false;
  @Input() showEditIcon: boolean = true;
  @Input() showSelectedItemBorder: boolean = false;
  @Input() isSpinnerVisible: boolean = true;

  @Output() searchText: EventEmitter<string> = new EventEmitter<string>();
  @Output() selectItem: EventEmitter<any> = new EventEmitter<any>();
  @Output() clearItem: EventEmitter<void> = new EventEmitter<void>();
  @Output() copyItem: EventEmitter<void> = new EventEmitter<void>();
  @Output() editItem: EventEmitter<void> = new EventEmitter<void>();
  @Output() clearSearch: EventEmitter<void> = new EventEmitter<void>();
  @Output() fetchMoreData: EventEmitter<void> = new EventEmitter<void>();

  searchStr: string = this.EMPTY; // Search input value
  tempSelectedItem: any = null;

  searchFormCtrl = new FormControl({ value: this.EMPTY, disabled: false });
  searchOptions = { size: Size.md };
  spinnerOptions: SpinnerOptions = {
    theme: SpinnerThemes.gray,
    thickness: '0.188rem',
    size: '1.563rem',
    isInverse: false,
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['selectedItem']) {
      this.tempSelectedItem = this.selectedItem;
      this.searchStr = this.EMPTY;
    }
  }

  onSearchInput(): void {
    if (!this.isPickerDisabled) {
      this.searchText.emit(this.searchStr);
    }
  }

  onSearchInputClick(): void {
    if (!this.isPickerDisabled && !this.isLoading && this.items.length > 0) {
      this.showDropdown = true;
    }
  }

  onSearchInputBlur(event: FocusEvent): void {
    event.stopPropagation(); // Remove if we want to direcetly go in read mode
    const relatedTarget = event.relatedTarget as HTMLElement;
    const isClickInside = relatedTarget?.closest('.dropdown-container');
    const searchContainer = relatedTarget?.closest('.generic-picker ');

    if (
      !this.isPickerDisabled &&
      !this.isLoading &&
      this.showDropdown &&
      !isClickInside &&
      !searchContainer
    ) {
      this.showDropdown = false;
    }
  }

  onSelectItem(item: any): void {
    if (!this.isPickerDisabled) {
      this.selectedItem = item;
      this.searchStr = this.EMPTY;
      this.selectItem.emit(item);
    }
  }

  onClearSearch(): void {
    if (!this.isPickerDisabled) {
      this.searchStr = this.EMPTY;
      this.isLoading = false;
      this.clearSearch.emit();
    }
  }

  clearSelectedItem(): void {
    if (!this.isPickerDisabled) {
      this.selectedItem = null;
      this.clearItem.emit();
    }
  }
  editSelectedItem(): void {
    if (!this.isPickerDisabled) {
      this.selectedItem = null;
      this.editItem.emit();
    }
  }

  copySelectedItem(): void {
    if (this.selectedItem) {
      copyToClipboard(this.selectedItem);
      this.copyItem.emit();
    }
  }

  onScroll(event: any): void {
    const { scrollTop, scrollHeight, clientHeight } = event.target;

    if (
      !this.isPickerDisabled &&
      this.items.length > 0 &&
      scrollTop + clientHeight + 1 >= scrollHeight
    ) {
      this.fetchMoreData.emit();
    }
  }
}
